import React from 'react';
import PropTypes from 'prop-types';


// A bottom navbar composed of the ResetButton, PrevButton, and NextButton
export default function NavBar({onClickPrev, onClickNext, onClickReset, showPrev, showNext, source, nextText}) {
    const sourceStyle={
      marginTop:'10px',
      color:'grey',
      fontSize:'12px'
    }

    return (
      <div>
        <nav className="d-flex justify-content-between">
          <button type="button" className="btn btn-link" onClick={onClickReset}>Reset</button>
          <div>
            {showPrev && <button type="button" className={`btn btn-primary mr-2`} onClick={onClickPrev}>Previous</button>}
            {showNext && <button type="button" className={`btn btn-primary mr-2`} onClick={onClickNext}>{nextText || "Next"}</button>}
          </div>
        </nav>
        <div style={sourceStyle} align="left">
          {source}
        </div>
      </div>
    )
};

NavBar.propTypes = {
  onClickPrev: PropTypes.func,
  onClickNext: PropTypes.func
};
